import React, {useState} from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Paper,
  Typography,
} from "@mui/material";
import Modal from "./Modal";
import { styled } from "@mui/system";
import { COLORS } from "../config/theme";
import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined';
import MoverDeOficina from "./MoverDeOficina";
import moment from "moment";

export const SeguimientoTable = ({ data, setReload, reload, accionMover = false, disabled=false, oficinasList }) => {
  const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    overflowY: "auto", // Habilita el scroll vertical si el contenido supera la altura
    marginTop: theme.spacing(2),
    boxShadow: theme.shadows
      ? theme.shadows[3]
      : "0 3px 5px rgba(0, 0, 0, 0.2)",
    borderRadius: theme.shape ? theme.shape.borderRadius : "4px",
  }));

  const StyledTableHead = styled(TableHead)(({ theme }) => ({
    backgroundColor: theme?.palette?.primary?.main || COLORS.SECONDARY,
    "& .MuiTableCell-head": {
      color: theme?.palette?.common?.white || "#fff",
      fontWeight: "bold",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme, index }) => ({
    backgroundColor:
      index % 2 === 0 ? theme?.palette?.action?.hover || "#f5f5f5" : "white",
  }));

  const tableStyle = {
    borderCollapse: "collapse",
    width: "100%",
    maxHeight: "100%",
  };

  
  const HeaderContainer = styled("div")(({ theme }) => ({
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: theme?.palette?.background?.paper || "#fff",
    padding: 6
  }));

  const cellStyle = {
    border: "1px solid #ddd",
    padding: "5px",
  };

  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);

  const moveToOffice = () => {
    setIsVisibleModal(true);
    setModalTitle("MOVER A OTRA OFICINA");
    setModalContent(
      <MoverDeOficina
      setIsVisibleModal={setIsVisibleModal}
      oficinasList={oficinasList}
      id_expediente={data[0].id_expediente}
      setReload={setReload}
      reload={reload}
      />
    );
  };

  return (
<>
      <StyledTableContainer component={Paper} style={{ marginTop: "0px" }}>
      <HeaderContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center"
          }}
        >
          <div
            style={{
              marginLeft: "auto",  // Esto empuja el div hacia la derecha
            }}
          >
            <DriveFileMoveOutlinedIcon
              style={{
                fontSize: 24,
                fontWeight: "bold",
                color: accionMover && !disabled ? COLORS.SECONDARY : COLORS.DISABLED,
                cursor: accionMover && !disabled ? "pointer" : "not-allowed",
              }}
              onClick={accionMover && !disabled ? moveToOffice : null}
            />
          </div>
        </div>
      </HeaderContainer>

      <Table style={tableStyle}>
        <StyledTableHead>
          <TableRow>
            <TableCell style={cellStyle}>Oficina</TableCell>
            <TableCell style={cellStyle}>Desde</TableCell>
            <TableCell style={cellStyle}>Hasta</TableCell>
            <TableCell style={cellStyle}>Usuario</TableCell>
          </TableRow>
        </StyledTableHead>
        {data.length > 0 ? (
          <TableBody>
            {data.map((row, index) => (
              <StyledTableRow key={index}>
                <TableCell style={cellStyle}>{row.oficina_nombre}</TableCell>
                <TableCell style={cellStyle}>
                  {moment(row.fecha).format("DD/MM/YYYY")}
                </TableCell>
                <TableCell style={cellStyle}>
                  {row.fecha_hasta
                    ? moment(row.fecha_hasta).format("DD/MM/YYYY")
                    : "--/--/----"}
                </TableCell>
                <TableCell style={cellStyle}>{row.usuario_nombre}</TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        ) : (
          <TableBody>
            <TableRow>
              <TableCell
                colSpan={4}
                style={{ textAlign: "center", padding: "10px" }}
              >
                <span style={{ fontWeight: "bold", fontSize: "1rem" }}>
                  Sin datos
                </span>
              </TableCell>
            </TableRow>
          </TableBody>
        )}
      </Table>
      </StyledTableContainer>
      <Modal
        title={modalTitle}
        open={isVisibleModal}
        setIsVisible={setIsVisibleModal}
      >
        {modalContent}
      </Modal>
    </>      
  );
};
